import React from "react";
import CustomerCard from "./CustomerCard";
import "./CustomerCards.css";

const CustomerCards = ({ data, onCardClick }) => {
  return (
    <div className='customercards'>
      {data &&
        data
          .sort((a, b) => a.active - b.active)
          .map((customer) => <CustomerCard customer={customer} onCardClick={onCardClick} />)}
    </div>
  );
};

export default CustomerCards;
